import React from 'react';

export const GroupsIcon = (props) => {
  const { className = '', style = {} } = props;

  return (
    <svg
      className={'custom-icon ' + className}
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      style={style}
    >
      <mask
        id="mask0_user_badge"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" />
      </mask>
      <g mask="url(#mask0_user_badge)">
        <path
          className="fill"
          d="M18.5106 9.87214C18.8816 10.2326 19.0625 10.6776 19.0638 11.186L19.0638 11.202C19.0638 11.7126 18.883 12.1594 18.5106 12.5211C18.1489 12.8828 17.7021 13.0743 17.1915 13.0743C16.6809 13.0743 16.234 12.8935 15.8723 12.5211C15.5121 12.1609 15.3207 11.7163 15.3192 11.2083L15.3191 11.1913C15.3191 10.6806 15.5106 10.2338 15.8723 9.87214C16.234 9.4998 16.6808 9.31895 17.1914 9.31895C17.7021 9.31895 18.1489 9.51044 18.5106 9.87214Z"
        />
        <path
          className="fill"
          d="M14.4043 10.2978L14.4043 10.3087C14.4042 10.9575 14.1701 11.5106 13.7128 11.9786C13.2553 12.436 12.6915 12.6701 12.0532 12.6701C11.4149 12.6701 10.8511 12.436 10.3936 11.9786C9.93617 11.5211 9.70213 10.9573 9.70213 10.3084L9.70215 10.2978C9.70215 9.64891 9.93619 9.08507 10.3936 8.62762C10.8511 8.17018 11.4149 7.93613 12.0532 7.93613C12.6915 7.93613 13.2553 8.17018 13.7128 8.62762C14.1702 9.09571 14.4043 9.6489 14.4043 10.2978Z"
        />
        <path
          className="fill"
          d="M6.89691 9.3298C7.39732 9.33552 7.8356 9.51649 8.19149 9.88285C8.55319 10.2446 8.74468 10.6914 8.74468 11.202C8.74468 11.7126 8.56383 12.1594 8.19149 12.5211C7.82979 12.8828 7.38298 13.0743 6.87234 13.0743C6.85843 13.0743 6.84457 13.0742 6.83075 13.0739C6.33304 13.0663 5.897 12.8753 5.54264 12.521C5.1703 12.1593 4.98945 11.7125 4.98945 11.2018C4.98945 10.6912 5.18094 10.2444 5.54264 9.88268C5.90435 9.51034 6.35116 9.32949 6.86179 9.32949L6.89691 9.3298Z"
        />
        <path
          className="fill"
          d="M14.9361 14.4896C15.1276 14.5641 15.3084 14.6492 15.468 14.745C16.3297 15.2662 16.7659 15.9684 16.7659 16.8513V17.4364C16.4361 17.713 16.0956 17.9684 15.7233 18.1918C14.6276 18.8513 13.351 19.2343 11.9893 19.2343C10.6276 19.2343 9.3616 18.8513 8.2765 18.2024C8.25522 18.1918 8.2366 18.1785 8.21799 18.1652C8.19937 18.1519 8.18075 18.1386 8.15947 18.1279C8.07144 18.0646 7.98574 18.0058 7.90121 17.9479C7.73038 17.8309 7.56432 17.7171 7.39352 17.5747C7.3616 17.5535 7.32969 17.5109 7.32969 17.5109V16.8513C7.32969 15.9684 7.76586 15.2662 8.62756 14.745C8.75918 14.6603 8.91572 14.5923 9.06782 14.5263L9.12756 14.5003C9.91479 14.1492 10.8935 13.9684 12.0425 13.9684C13.1914 13.9684 14.1488 14.1492 14.9361 14.4896Z"
        />
        <path
          className="fill"
          d="M7.9361 14.2025C7.55312 14.1386 7.12758 14.0961 6.67014 14.0961C5.98929 14.0961 5.40418 14.1812 4.87227 14.3195C5.19141 15.2769 5.71269 16.1174 6.37227 16.8621C6.39354 16.0748 6.70205 15.0216 7.9361 14.2025Z"
        />
        <path
          className="fill"
          d="M17.2658 14.0961C16.8083 14.0961 16.3828 14.1386 15.9998 14.2025C17.2338 15.0216 17.5424 16.0748 17.5636 16.8621C18.2232 16.1174 18.7445 15.2769 19.0636 14.3195C18.5317 14.1812 17.9466 14.0961 17.2658 14.0961Z"
        />
        <path
          className="fill"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 12C2 6.48936 6.48936 2 12 2C17.5106 2 22 6.48936 22 12C22 17.5106 17.5106 22 12 22C6.48936 22 2 17.5106 2 12ZM20.1596 12C20.1596 7.48936 16.5106 3.84043 12 3.84043C7.48936 3.84043 3.84043 7.5 3.84043 12C3.84043 16.5 7.48936 20.1596 12 20.1596C16.5106 20.1596 20.1596 16.5106 20.1596 12Z"
        />
      </g>
    </svg>
  );
};
